let apiUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_ET;
import { decrypt, encrypt } from "@/vendor/crypto";

class ET {
  static getTickets() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getTickets`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static generateQrcode(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/generateQrcode`, params, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }
}

export default ET;
